import React, { useState, useEffect } from "react";
import "../../CSS/Global.css";
import { useSidebar } from "../../SidebarContext";
import Header from "../Header";
import Sidebar from "../SideBar";
import Swal from "sweetalert2";

const EarningEvent = () => {
  const { isSidebarOpen } = useSidebar();
  const [searchQuery, setSearchQuery] = useState("");
  const [employees, setEmployees] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [activeTab, setActiveTab] = useState("Subscribers");
  const url = process.env.REACT_APP_LINK;
  const token = localStorage.getItem("token");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Fetch earnings
  const fetchUsers = async () => {
    try {
      const response = await fetch(`${url}/api/event/earnings`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      setEmployees(data.data || []);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // ✅ Single delete
  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This record will be deleted.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
    });

    if (result.isConfirmed) {
      try {
        const response = await fetch(`${url}/api/event/earning/${id}`, {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const res = await response.json();
        if (response.ok) {
          setEmployees((prev) => prev.filter((e) => e.id !== id));
          Swal.fire("Deleted!", res.message || "Record deleted.", "success");
        } else {
          Swal.fire("Error!", res.error || "Something went wrong.", "error");
        }
      } catch (error) {
        Swal.fire("Error!", "Something went wrong.", "error");
      }
    }
  };

  // ✅ Mark as success
  const handleSuccess = async (id) => {
    try {
      const response = await fetch(`${url}/api/event/eventearning/${id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ payStatus: "Success" }),
      });
      if (response.ok) {
        setEmployees((prev) =>
          prev.map((emp) =>
            emp.id === id ? { ...emp, payStatus: "Success" } : emp
          )
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  // ✅ Multi delete handler
  const handleDeleteSelected = async () => {
    if (selectedIds.length === 0) {
      Swal.fire("No Selection", "Please select at least one record.", "info");
      return;
    }

    const result = await Swal.fire({
      title: "Delete Selected?",
      text: `You are about to delete ${selectedIds.length} record(s).`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete them!",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
    });

    if (result.isConfirmed) {
      try {
        // Loop delete (or you can make one backend endpoint for bulk delete)
        for (const id of selectedIds) {
          await fetch(`${url}/api/event/earning/${id}`, {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
        }

        setEmployees((prev) => prev.filter((emp) => !selectedIds.includes(emp.id)));
        setSelectedIds([]);
        Swal.fire("Deleted!", "Selected records deleted successfully.", "success");
      } catch (error) {
        Swal.fire("Error!", "Something went wrong during deletion.", "error");
      }
    }
  };

  // ✅ Selection handlers
  const toggleSelectAll = (checked) => {
    if (checked) {
      setSelectedIds(currentEmployees.map((emp) => emp.id));
    } else {
      setSelectedIds([]);
    }
  };

  const toggleSelect = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  // ✅ Search + filter + pagination
  const filteredEmployees = employees.filter(
    (emp) =>
      emp.type === activeTab &&
      Object.values(emp).some((val) =>
        String(val).toLowerCase().includes(searchQuery.toLowerCase())
      )
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentEmployees = filteredEmployees.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const totalPages = Math.ceil(filteredEmployees.length / itemsPerPage);

  return (
    <>
      <Header />
      <Sidebar />
      <div className={`open-close ${isSidebarOpen ? "open" : "closed"}`}>
        <div className="oms-header">
          <h1 className="dashboard-title">Event Earnings</h1>

          <div
            className="tab-container"
            style={{ display: "flex", gap: "10px", marginBottom: "15px" }}
          >
            <button
              className={`tab-btn ${activeTab === "Subscribers" ? "active" : ""
                }`}
              onClick={() => setActiveTab("Subscribers")}
            >
              Subscribers
            </button>
            <button
              className={`tab-btn ${activeTab === "Watch" ? "active" : ""}`}
              onClick={() => setActiveTab("Watch")}
            >
              Watch Time
            </button>
          </div>

          {/* 🧹 Delete Selected Button */}
          {selectedIds.length > 0 && (
            <button
              onClick={handleDeleteSelected}
              style={{
                background: "#d33",
                color: "#fff",
                border: "none",
                padding: "8px 12px",
                borderRadius: "6px",
                cursor: "pointer",
                fontSize: "14px",
                marginBottom: "10px",
              }}
            >
              Delete Selected ({selectedIds.length})
            </button>
          )}
        </div>

        {/* Search */}
        <div className="filter-search">
          <div className="filter-search-input">
            <input
              type="search"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <i className="fa fa-search"></i>
          </div>
        </div>

        {/* Table */}
        <div className="customer-table">
          <table>
            <thead>
              <tr>
                <th>No.</th>
                <th>
                  <input
                    type="checkbox"
                    onChange={(e) => toggleSelectAll(e.target.checked)}
                    checked={
                      currentEmployees.length > 0 &&
                      selectedIds.length === currentEmployees.length
                    }
                  />
                </th>
                <th>Name</th>
                <th>ID</th>
                <th>
                  {activeTab === "Watch"
                    ? "Watch Time (hrs)"
                    : "Subscribers"}
                </th>
                <th>Event</th>
                <th>Earning</th>
                <th>Pay Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {currentEmployees.length > 0 ? (
                currentEmployees.map((emp, index) => (
                  <tr key={index}>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}.</td>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedIds.includes(emp.id)}
                        onChange={() => toggleSelect(emp.id)}
                      />
                    </td>
                    <td>{emp.user_name}</td>
                    <td>{emp.user_id}</td>
                    <td>
                      {activeTab === "Watch"
                        ? `${Math.floor(emp.watchtime / 60)}h ${emp.watchtime % 60
                        }m`
                        : parseInt(emp.subscribers_count, 10)}
                    </td>
                    <td>{emp.event_name}</td>
                    <td>{emp.earning}</td>
                    <td>{emp.payStatus}</td>
                    <td>
                      <button
                        onClick={() => handleSuccess(emp.id)}
                        style={{
                          background: "transparent",
                          border: "none",
                          color: "green",
                          fontSize: "16px",
                          cursor: "pointer",
                        }}
                      >
                        <i className="fa-solid fa-check success-oms"></i>
                      </button>
                      <button
                        className="delete-button"
                        onClick={() => handleDelete(emp.id)}
                      >
                        <i className="fa-solid fa-trash delete-oms"></i>
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="12" style={{ textAlign: "center" }}>
                    No records found for {activeTab}.
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {/* Pagination */}
          <div
            className="pagination"
            style={{ marginTop: "15px", marginBottom: "20px", textAlign: "center" }}
          >
            {/* Prev Button */}
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className="page-btn"
            >
              Prev
            </button>

            {/* Always show first page */}
            <button
              onClick={() => setCurrentPage(1)}
              className={`page-btn ${currentPage === 1 ? "active" : ""}`}
            >
              1
            </button>

            {/* Show "..." if needed before current range */}
            {currentPage > 3 && <span className="dots">...</span>}

            {/* Show middle range dynamically */}
            {Array.from({ length: totalPages }, (_, i) => i + 1)
              .filter(
                (page) =>
                  page !== 1 && // skip first
                  page !== totalPages && // skip last
                  page >= currentPage - 1 && // show one before
                  page <= currentPage + 1 // show one after
              )
              .map((page) => (
                <button
                  key={page}
                  onClick={() => setCurrentPage(page)}
                  className={`page-btn ${currentPage === page ? "active" : ""}`}
                >
                  {page}
                </button>
              ))}

            {/* Show "..." if needed after current range */}
            {currentPage < totalPages - 2 && <span className="dots">...</span>}

            {/* Always show last page if more than one */}
            {totalPages > 1 && (
              <button
                onClick={() => setCurrentPage(totalPages)}
                className={`page-btn ${currentPage === totalPages ? "active" : ""}`}
              >
                {totalPages}
              </button>
            )}

            {/* Next Button */}
            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
              className="page-btn"
            >
              Next
            </button>
          </div>

        </div>
      </div>
    </>
  );
};

export default EarningEvent;
